import axios from 'axios';
import { API_BASE_URL,feedbackCheckMethod } from "../config";

const feedbackService = {
  async hasSubmittedFeedback(encryptedData) {
    if (feedbackCheckMethod === 'localStorage') {
      return localStorage.getItem('feedbackSubmitted') === 'true';
    } else {
      try {
        const response = await axios.post(`${API_BASE_URL}/x1bf/x1wh/member/check-feedback-submission`, {
          data: encryptedData
        });
        return response.data.status === 'success' && response.data.data.has_submitted;
      } catch (error) {
        console.error('Error checking feedback submission:', error);
        return false; // Fallback to false on error
      }
    }
  },

  async recordFeedbackSubmission(encryptedData) {
    if (feedbackCheckMethod === 'localStorage') {
      localStorage.setItem('feedbackSubmitted', 'true');
    } else {
      try {
        await axios.post(`${API_BASE_URL}/x1bf/x1wh/member/record-feedback-submission`, {
          data: encryptedData
        });
      } catch (error) {
        console.error('Error recording feedback submission:', error);
      }
    }
  }
};

export default feedbackService;